const getters = {
  getUser: (state) => state.user
};

export default {
  getters
};
